import type { InviteByEmailData } from '../types';

export const EmailInviteApi = Symbol('EmailInviteApi');

export interface EmailInviteApi {
  inviteByEmail(initData: InviteByEmailData): Promise<boolean>;
}
